import { usePageSeo } from '@/hooks/usePageSeo';
import { SITE, SITE_URL } from '@/config/site';
import { topics } from '@/mocks/topics';
import { homeFaqs } from '@/mocks/faqs';
import HeroSection from '@/pages/home/components/HeroSection';
import HotRanking from '@/pages/home/components/HotRanking';
import CategorySection from '@/pages/home/components/CategorySection';
import FeaturedTopics from '@/pages/home/components/FeaturedTopics';
import OpinionSection from '@/pages/home/components/OpinionSection';
import FaqSection from '@/pages/home/components/FaqSection';
import NewsletterSection from '@/pages/home/components/NewsletterSection';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE.name,
    url: SITE_URL,
    inLanguage: 'zh-CN',
    description: '聚焦网络热点话题的观察型内容站点，呈现热搜话题、观点分布与评论区实录。',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/topics?keyword={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE.name,
    url: SITE_URL,
    email: SITE.email,
    description: SITE.intro,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '当前热门话题',
    itemListElement: topics.map((t, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: t.title,
      url: `${SITE_URL}/topics/${t.id}`,
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: homeFaqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  },
];

export default function Home() {
  usePageSeo({
    title: '吃瓜观察局｜热搜话题与舆论风向观察',
    description:
      '吃瓜观察局聚焦网络热点话题，整理热搜话题的时间脉络、网友观点分布与评论区实录，帮你看清大家在讨论什么、舆论风向如何变化。',
    keywords: '黑料大瓜,热搜话题,网友讨论,吃瓜现场,舆论风向,评论区',
    path: '/',
    jsonLd,
  });

  return (
    <>
      <HeroSection />
      <HotRanking />
      <CategorySection />
      <FeaturedTopics />
      <OpinionSection />
      <FaqSection />
      <NewsletterSection />
    </>
  );
}